<div class="text-center d-flex flex-column" style="border-radius: 10px">
  <form (ngSubmit)="onConfirm()" *ngIf="active">
    <h4 class="modal-title pull-left mb-5">
      {{title}}
    </h4>
    <div>
      <button type="button" class="btn btn-dark w-100 mb-3" (click)="onConfirm()">
        ¡Sí, está correcto!
      </button>
    </div>
    <div class="mb-5">
      <button type="button" class="btn cancel-button w-100" (click)="onCancel()">
        Cancelar
      </button>
    </div>
    <div class="d-flex justify-content-center align-items-center" *ngIf="showReturn">
      <i class="bi bi-chevron-left back-icon me-4"></i>
      <b>O puedes <span class="back-text" (click)="onReturn()">volver a la edición</span></b>
    </div>
  </form>
</div>